// Step-specific quick questions shown in the LLC Guide Assistant, keyed by chapter id (page index in the eBook).
export const stepQuestions = {
  0: [
    "Do I really need a separate business address before filing?",
    "Which virtual mailbox is cheapest for a solo founder?",
    "Can I use Google Voice as my LLC's business phone?",
  ],
  1: [
    "How do I check if my LLC name is available in Texas?",
    "Which words are restricted in a Texas LLC name?",
    "Do I need to reserve my name before filing?",
  ],
  2: [
    "Can I be my own registered agent?",
    "What does a registered agent actually do?",
    "How much does a registered agent service cost?",
  ],
  3: [
    "How much does it cost to file Form 205?",
    "How long does SOSDirect take to approve my filing?",
    "What information do I need before filing the Certificate of Formation?",
  ],
  4: [
    "Is an Operating Agreement required in Texas?",
    "What should a single-member Operating Agreement include?",
    "Do I file the Operating Agreement with the state?",
  ],
  5: [
    "How do I get an EIN for free?",
    "Can I apply for an EIN before my LLC is approved?",
    "Do I need an EIN if I'm a single-member LLC with no employees?",
  ],
  6: [
    "What documents does a bank need to open an LLC account?",
    "Why should I keep business and personal money separate?",
    "Which banks are good for a new Texas LLC?",
  ],
  7: [
    "When is the Texas franchise tax report due?",
    "Do I owe franchise tax if my LLC made no money?",
    "What is the no-tax-due threshold?",
  ],
  8: [
    "How do I know which licenses my business needs?",
    "Do I need a Texas sales tax permit?",
    "Where do I check for city or county permits?",
  ],
  9: [
    "What do I have to file every year to stay compliant?",
    "How do I update my registered agent or address?",
    "What happens if I miss a franchise tax deadline?",
  ],
  cost: [
    "What's the minimum I can spend to form a Texas LLC?",
    "Which costs are optional vs. required?",
    "Are there any hidden or recurring fees?",
  ],
};
